import React from "react"
import type { StyleProps } from "@mallardbay/lib-react-components"
import {
    ActionBanner,
    ColorSchemes,
    HorizontalStack,
    Text,
} from "@mallardbay/lib-react-components"

import QuotePaymentPlanSummary from "~components/shared/quote/quote-payment-plan-summary"
import type { QuotePaymentPlanFieldsFragment } from "~graphql/generated/graphql"
import { TextLargeBold } from "~components/shared/todo-lib-react-components/text"
import COPY from "~config/copy-constants"

interface Props {
    readonly paymentPlan: QuotePaymentPlanFieldsFragment
    readonly onLearnMoreClick: () => void
    readonly isLoading?: boolean
}

export default function PaymentPlanRadioOption({
    paymentPlan,
    onLearnMoreClick,
    isLoading,
}: Props) {
    const styles = useStyles()
    const hasMultiplePayments = paymentPlan.payments.length > 1

    return (
        <div>
            <HorizontalStack style={styles.planInfoContainer}>
                <TextLargeBold>{paymentPlan.name}</TextLargeBold>
            </HorizontalStack>
            <QuotePaymentPlanSummary
                paymentPlan={paymentPlan}
                isLoading={isLoading}
            />
            {hasMultiplePayments && (
                <ActionBanner
                    style={styles.actionBanner}
                    title={COPY.FLEXIBLE_PAYMENTS_TITLE}
                    ctaLabel={COPY.LEARN_MORE}
                    colorScheme={ColorSchemes.Green}
                    ctaOnClick={onLearnMoreClick}
                >
                    <Text>{COPY.FLEXIBLE_PAYMENTS_DESCRIPTION}</Text>
                </ActionBanner>
            )}
        </div>
    )
}

function useStyles() {
    const planInfoContainer: StyleProps = {
        marginBottom: 2,
    }

    const actionBanner: StyleProps = {
        marginTop: 2,
    }

    return { planInfoContainer, actionBanner }
}
